module.exports = __webpack_public_path__ + "media/images/icon-appearances-553b91aaf55a4a95517f5b5ba30abfe6.svg";